import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/atoms/Dialog";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from "@/components/atoms/Drawer";
import FormAddEditReview from "@/components/molecules/AddEditReviewModal/formAddEditReview";
import type { IResponsiveDialogProps } from "@/components/molecules/AddEditReviewModal/types";
import type { IReview } from "@/components/pages/SinglePageApp/types";
import { AddOrEditEnum } from "@/components/pages/SinglePageApp/types";
import { useMediaQuery } from "@/hooks/common/useMediaQuery";
import { useTranslations } from "@/hooks/common/useTranslations";

import { SCREEN_SIZES } from "@/common/globalTypes/enums/common";

const AddEditReviewModal = ({
  open,
  review,
  onClose,
  createOrUpdateReview,
  isLoadingCreateEditReview,
  isLoadingAppReview,
}: IResponsiveDialogProps) => {
  const { t } = useTranslations("SingleAppPage");
  const isMobile = useMediaQuery(SCREEN_SIZES.sm);
  const isEditMode = Boolean(review?.id);
  const title = t(
    isEditMode || isLoadingAppReview ? "editReview" : "writeReview",
  );

  const description = t(
    isEditMode || isLoadingAppReview ? "updateReviewDesc" : "addReviewDesc",
  );

  const isLoadingAddEditReviewModal =
    isLoadingCreateEditReview || isLoadingAppReview;

  const onSubmit = (formValues: IReview) => {
    if (isEditMode) {
      const reviewId = review?.id;
      const editedReviewPayload = { ...formValues, reviewId };

      return createOrUpdateReview(editedReviewPayload, AddOrEditEnum.edit);
    }

    return createOrUpdateReview(formValues, AddOrEditEnum.add);
  };

  if (isMobile) {
    return (
      <Drawer open={open} onClose={onClose}>
        <DrawerContent>
          <DrawerHeader className="text-left">
            <DrawerTitle>{title}</DrawerTitle>
            <DrawerDescription>{description}</DrawerDescription>
          </DrawerHeader>
          <FormAddEditReview
            onSubmitFormData={onSubmit}
            isLoadingAddEditReviewModal={isLoadingAddEditReviewModal}
            isLoadingSkeleton={isLoadingAppReview}
            review={review}
            onClose={onClose}
          />
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[576px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>

        <FormAddEditReview
          onSubmitFormData={onSubmit}
          isLoadingAddEditReviewModal={isLoadingAddEditReviewModal}
          isLoadingSkeleton={isLoadingAppReview}
          review={review}
          onClose={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AddEditReviewModal;
